<template>
  <of-dialog
    title="请选择"
    :appendToBody="true"
    @onCancel="close"
    @onConfirm="confirm"
    @onDialogResize="dialogResize"
    confirmName="确 定"
    width="850px"
  >
    <div slot="content" style="padding:10px">
      <el-row :gutter="5">
        <el-col :span="15">
          <div class="panel department-nav">
            <header>待选部门</header>
            <div class="content" ref="leftArea">
              <div class="tree-nav">
                <el-tree
                  :lazy="lazyLoad"
                  :load="loadTreeData"
                  :data="treeData"
                  ref="ofTree"
                  v-loading="isLoading"
                  node-key="id"
                  :default-expanded-keys="defaultExpandedKeys"
                  :check-strictly="checkStrictly"
                  @node-click="selectNode"
                  icon-class="iconClass  el-tree-node__expand-icon el-icon-caret-right"
                >
                  <span class="tree-node" slot-scope="{ node, data }">
                    <!-- <i v-show="showIcon" class="tree-node-icon" :class="iconClassName ? iconClassName : (data.icon?data.icon:'el-icon-menu')"></i> -->
                    <span :title="data&&data.data?data.data.FullDepartmentName:''">{{ data.text }}</span>
                  </span>
                </el-tree>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="9">
          <div class="panel options-nav">
            <header>
              已选部门
              <span>{{departmentData.length}}</span>
            </header>
            <div class="content" ref="rightArea">
              <p
                class="last-dept-item"
                :title="item&&item.data?item.data.FullDepartmentName:''"
                v-for="(item,index) in departmentData"
                :key="index"
              >
                <i class="fa fa-remove" @click="departmentData.splice(index,1)" title="移除"></i>&nbsp;
                <span>{{item.text}}</span>
              </p>
              <p class="no-more" v-show="!departmentData.length">无数据</p>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        最近使用：
        <span v-for="(item,index) in lastUseDepartment" :key="index" :title="item&&item.data?item.data.FullDepartmentName:''">
          <el-button class="last-select-item" round  @click="selectNode(item)" type="text" size="mini">{{item.text|filterDeptName}}</el-button>
        </span>
      </el-row>
    </div>
  </of-dialog>
</template> 

<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import { queryDepartmentPickData } from "@/modules/sys/api/department.js";
 
export default {
  name: "sys-department-picker",
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    checkStrictly: {
      type: Boolean,
      default: false
    },
    checkedData: {
      type: Array,
      default: function() {
        return [];
      }
    },
    lazyLoad: {
      type: Boolean,
      default: true
    },
    topDeptId:{
      type:String,
      default:''
    },
    defaultExpandedKeys:{
      type: Array,
      default(){
        return []
      }
    },
    firstDept:{
      type: Array,
      default(){
        return []
      }
    },
    onlyDpet:{
      type: String,
      default: ''
    }
  },
  data() {
    return {
      treeData: [],
      isLoading: false,
      departmentUrl: "/Sys/Picker/queryDepartmentTree",
      departmentData: [],
      lastUseDepartment: []
    };
  },
  components: {
    OfDialog
  },
  mounted() {
    this.checkedData.forEach(x => {
      this.departmentData.push(x);
    });

    let lastDepart = localStorage.getItem("LAST_USE_DEPARTMENT");
    if (lastDepart) {
      let lastDept = JSON.parse(lastDepart)
      if(this.topDeptId){
        lastDept = lastDept.filter(x=>x.data&&x.data.FullDepartmentId.indexOf(this.topDeptId)>-1)
      }
      this.lastUseDepartment = lastDept
    }
  },
  filters: {
    filterDeptName(val){
      if(val.length>10){
          val = val.substr(0,10)+'...'
      }
      return val
    }
  },
  methods: {
    loadTreeData(node, resolve) {
      node.level === 0 && (this.isLoading = true);
      queryDepartmentPickData(node.level === 0 ? this.topDeptId : node.key)
        .then(rep => {
          this.isLoading = false;
          if (rep.data && rep.data.Code === 0) {
            let respData = rep.data.Data;
            if(this.firstDept.length>0){
              for(let i=0;i<respData.length;i++) {
                if(this.firstDept.findIndex(m=>m===respData[i].id)>-1){
                  let t = respData.splice(i,1)
                  respData.splice(0,0,t[0])
                  break;
                }
              }
            }
            if(this.onlyDpet){
              let onlyIndex = respData.findIndex(x=>x.id===this.onlyDpet)
              if(onlyIndex>-1){
                let t = respData[onlyIndex]
                respData = [t];
              }
            }
            return resolve(respData);
          }
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    close() {
      this.$emit("pickerCallBack", null);
    },
    confirm() {
      if (this.departmentData.length === 0) {
        this.$message({
          message: "请选择部门",
          type: "warning"
        });
      } else {
        if (this.multiple) {
          this.$emit("pickerCallBack", this.departmentData);
          this.setLastStorage(this.departmentData);
        } else {
          this.$emit("pickerCallBack", this.departmentData[0]);
          this.setLastStorage([this.departmentData[0]]);
        }
      }
    },
    setLastStorage(arr) {
      let lastCount = 20;
      arr.forEach(data => {
        let i = this.lastUseDepartment.findIndex(x => x.id === data.id);
        if (i > -1) {
          this.lastUseDepartment.splice(i, 1);
        }
        this.lastUseDepartment.unshift(data);
      });
      this.lastUseDepartment.splice(lastCount, this.lastUseDepartment.length - lastCount);
      localStorage.setItem(
        "LAST_USE_DEPARTMENT",
        JSON.stringify(this.lastUseDepartment)
      );
    },
    selectNode(data) {
      if (this.multiple) {
        let index = this.departmentData.findIndex(x => x.id === data.id);
        if (index === -1) {
          this.departmentData.push(data);
        }
      } else {
        this.departmentData = [];
        this.departmentData.push(data);
      }
    },
    dialogResize(height) {
      let leftArea = this.$refs.leftArea;
      let rightArea = this.$refs.rightArea;
      let lastUseArea = this.$refs.lastUseArea;

      height -= 110;
      if (leftArea) {
        leftArea.style.maxHeight = `${height}px`;
        leftArea.style.minHeight = `${height}px`;
      }
      if (rightArea) {
        rightArea.style.maxHeight = `${height}px`;
        rightArea.style.minHeight = `${height}px`;
      }
      if (lastUseArea) {
        lastUseArea.style.maxHeight = `${height}px`;
        lastUseArea.style.minHeight = `${height}px`;
      }
    }
  }
};
</script>
<style scoped>
.panel {
  border: 1px solid #ebeef5;
  overflow: hidden;
  width: 100%;
  border-radius: 3px;
}
.department-nav {
  min-width: 300px;
}
.options-nav {
  min-width: 200px;
}
.panel > header {
  background: #f5f7fa;
  padding: 5px 10px 5px 10px;
  border-bottom: 1px solid #ebeef5;
  position: relative;
}
.panel > header > span {
  position: absolute;
  right: 15px;
  color: #909399;
  font-size: 12px;
  font-weight: 400;
}
.panel > .content {
  padding: 10px;
  overflow: auto;
}
.no-more {
  padding: 5px;
  color: #909399;
  text-align: center;
}
.tree-nav >>> .iconClass {
  color: #555;
  font-size: 15px;
}
.last-dept-item {
  font-size: 14px;
  cursor: pointer;
  margin-bottom: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.last-dept-item > span:hover {
  color: #004a86;
}
.last-dept-item .fa-remove:hover {
  color: #ff0000;
}
.last-select-item{
  margin-bottom:5px;margin-left:5px;padding: 3px 10px;overflow: auto;
}
</style>
